<template>
    <div class="pickerSearchWrapper">
      
      <div class="pickerActionArea">
        <input
          type="text"
          v-model="query"
          v-bind:placeholder="placeholder"
          class="pickerSearchInput"
          ref="stickerSearchInput"
          autocomplete="false"
          @change.prevent="search(query)"
        >
        <button @click.stop="search(query)" class="btn green pickerSearchInputBtn">Search</button>
      </div>

      <div class="pickerSearchResults">
        
        <div v-if="loading" class="loading"></div>

        <template v-if="searchResults.length > 0 && !loading">
          <img
            v-for="(item, index) in searchResults"
            :src="item.images.fixed_width.url"
            :key="index"
            class="gifItem"
            @click.prevent="selectItem(item.images.fixed_width.url)"
          >
        </template>
      </div>
    </div>
</template>

<script>
export default {
    name: 'StickerSearch',
    props: {
        placeholder: {
            type: String,
            default: ''
        },
        version: {
            type: String,
            default: 'v1'
        }
    },
    data: function () {
        return {
            query: '',
            loading: false,
            searchResults: {
                type: Array,
                default: () => {
                    return []
                }
            }
        }
    },
    mounted(){
        this.$refs.stickerSearchInput.focus()
    },
    methods: {
        search(query){
            this.loading = true
            this.searchResults = []

            if(this.version === 'v1'){

                let key = 'IrzOpkMNFt1ryQ_ck7torA'
                key = 'dc6zaTOxFJmzC'

                // https://api.mojilala.com/v1/stickers/search?q=cat&api_key=IrzOpkMNFt1ryQ_ck7torA
                
                this.$http.get(`https://api.mojilala.com/v1/stickers/search?q=${query}&api_key=${key}`).then(response => {
                    
                    console.log('Sticker results: ', response)

                    if(response.body.data){
                        this.searchResults = response.body.data
                    }

                    this.loading = false
                
                }, error => {
                    console.log('Sticker search error: ', error)
                    this.loading = false
                })
            
            }else if(this.version === 'v2'){

                let key = '7a62d5d803be91e1b7449d99c1ca701c'
                let user = 'OneMgl'

                this.$http.get(`https://messenger.stipop.io/v1/package?apikey=${key}&userId=${user}&country=ca&searchText=${query}`).then(response => {
                    
                    console.log('Sticker results: ', response)

                    if(response.body.data){
                        this.searchResults = response.body.data
                    }

                    this.loading = false
                
                }, error => {
                    console.log('Sticker search error: ', error)
                    this.loading = false
                })
            }
        },
        reset(){
            this.query = ''
            this.searchResults = []
        },
        selectItem(itemUrl){
            this.reset()
            this.$emit('onSelected', itemUrl)
        }
    }    
}
</script>


// WEBPACK FOOTER //
// src/components/StickerSearch.vue